import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectLabelNames = (store: StoreSchema) => store.client.labelNames